import React, { ReactNode } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { TranscriptionCacheProvider } from "./contexts/TranscriptionCacheContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import { ErrorBoundary } from "./components/ErrorBoundary";
import Profile from "./pages/Profile";
import Auth from "./pages/Auth";
import { LoadingOverlay } from "./components/LoadingOverlay";

function PrivateRoute({ children }: { children: ReactNode }): JSX.Element {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen">
                {children}
                <LoadingOverlay 
                    message="Checking authentication..." 
                    fullScreen 
                />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}

function App() {
    return (
        <AuthProvider>
            <ToastProvider>
                <TranscriptionCacheProvider>
                    <ErrorBoundary>
                    <Router>
                        <Routes>
                            <Route path="/" element={<Layout />}>
                                <Route index element={<Home />} />
                                <Route path="auth" element={<Auth />} />
                                <Route
                                    path="dashboard"
                                    element={
                                        <PrivateRoute>
                                            <Dashboard />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="history"
                                    element={
                                        <PrivateRoute>
                                            <History />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="profile"
                                    element={
                                        <PrivateRoute>
                                            <Profile />
                                        </PrivateRoute>
                                    }
                                />
                            </Route>
                        </Routes>
                    </Router>
                    </ErrorBoundary>
                </TranscriptionCacheProvider>
            </ToastProvider>
        </AuthProvider>
    );
}

export default App;
